import { graphql } from "react-relay";
import { EventSchedulerSuggestedTime } from "@components/event-scheduler-suggested-time";

export const eventSchedulerSuggestedTimesFragments = {
  schedulingResponse: graphql`
    fragment EventSchedulerSuggestedTimes_schedulingResponse on SchedulingResponse {
      uncrawledCalendars
      qualifiers
      queryRecommendation {
        availableDate
        minutesDuration
      }
      slots {
        ...EventSchedulerSuggestedTime_schedulingSlot
        summary {
          availableRooms
          tags
          freeAttendees
          inconvenientForAttendees
          focusTimeMinutesCost
          conflictingAttendees
        }
        attendanceImpacts {
          calendarId
          inconveniences
          hasConflict
          focusTimeMinutesCost
          conflictingMeetings
        }
        roomImpacts {
          available
          tooSmall
          tooLarge
          roomId
        }
        timeRange {
          id
          startTime {
            type
            dateOrDateTime
            timeZone
            offsetMinutes
            millis
          }
          endTime {
            type
            dateOrDateTime
            timeZone
            offsetMinutes
            millis
          }
        }
      }
    }
  `,
  org: graphql`
    fragment EventSchedulerSuggestedTimes_org on Org {
      id
      ...EventSchedulerSuggestedTime_org
      workingGroups(first: 1000000) {
        edges {
          node {
            rooms {
              roomId
              name
            }
          }
        }
      }
    }
  `,
};
